import React, { Component } from 'react';

class Dialog extends Component{
    constructor(props){
        super(props);
        this.state = {
            show: false
        };

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);        
    }

    show(){
        this.setState({
            show: true
        });    
    }

    hide(){
        this.setState({
            show: false
        });
    }  
}

export default Dialog;


// WEBPACK FOOTER //
// app/components/Dialog.jsx